import angular from 'angular';
import uiRouter from 'angular-ui-router';
import BulkUploadComponent from './bulkUpload.component';
import routing from './bulkUpload.routes';

export default angular
  .module('verifyApp.cases.bulkUpload', [uiRouter])
  .config(routing)
  .component('bulkUpload', BulkUploadComponent)
  .name;



// WEBPACK FOOTER //
// ./client/app/cases/bulkUpload/index.js